/**
* @description: 积分规则
*/
<template>
    <div class="finance_box" ref="myElementRef">
        <div ref="searchBox">
            <!-- <hc-search :data="searchData" @serch="getSearch">
                <template #btns>
                    <el-button type="primary" icon="Plus"
                        @click="$refs['addRule'].open()">新增</el-button>
                </template>
            </hc-search> -->
            <el-button type="primary" icon="Plus"
                        @click="$refs['addRule'].open()">{{ t('scoreRule.addRule') }}</el-button>
        </div>
        <!-- 表格 -->
        <div class="table_box">
            <hc-table :tableData="state.tableData" :column="state.tableHeader" :offsetHeight="state.offsetHeight"
                :maxPage="maxPage"
                @pageChange="pageChange" @limitChange="limitChange">
                <template #operation="scope">
                    <div class="btn_box_det">
                        <el-button class="opBtn" size="small" type="primary" link
                            @click="$refs['addRule'].open(scope.row)">{{ t('common.edit') }}</el-button>
                    </div>
                </template>
            </hc-table>
        </div>
        <!-- 新增 -->
        <EditRule ref="addRule" :title="state.title" @refresh="getSearch(searchData)" />
    </div>
</template>

<script setup>
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { onMounted, reactive, ref, nextTick, onUnmounted, onActivated, toRaw } from "vue";
import EditRule from "./components/editRule.vue";

import { pageListApi } from "@/api/score/rule.js";
import { listToMap } from "@/utils/utils";
import { usePageI18n } from "@/composables/usePageI18n.js";
import { applyScoreRuleListLabels } from "@/utils/scoreListI18n.js";
const myElementRef = ref();
const searchBox = ref();
const addRule = ref();

let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);
const searchData = reactive([
    {
        label: "关键词",
        type: "input",
        value: "",
        field: 'keywords',
        placeholder: "请输入",
    },
]);

const statusOptions = reactive([
    { label: "启用", value: 1 },
    { label: "禁用", value: 0 }
])

const applyLabels = () => {
    applyScoreRuleListLabels({ columns: state.column, statusOptions });
    tableHeaderFn();
};
const { t } = usePageI18n(applyLabels);

const state = reactive({
    title: "",
    column: [
        {
            prop: "id",
            show: false,
            label: "记录ID",
        },
        {
            // prop: "id",
            show: true,
            type: "index",
            label: "序号",
            width: 80,
        },
        {
            prop: "level_name",
            show: true,
            label: "等级名称",
        },
        {
            prop: "required_points",
            show: true,
            label: "所需积分",
            sortable: true
        },
        {
            prop: "status",
            show: true,
            label: "状态",
        },
        {
            prop: "operation",
            show: true,
            label: "操作",
        },
    ],
    offsetHeight: 0,
    tableHeader: [],
    tableData: [
        {
            //   "reason": "技能学习",
            //   "user_id": 1,
            //   "mobile": "13456214521",
            //   "created_at": "2025-05-08 19:38:41",
            //   "change_type": 1,
            //   "real_name": "张三",
            //   "id": 1,
            //   "points": 10,
            //   "username": "jishou0001"
        }
    ]
});

const init = () => {
    getSearch(searchData)
};

// 动态改变表头
const change = (item) => {
    tableHeaderFn();
};

const offHeighths = () => {
    if (myElementRef.value) {
        state.offsetHeight =
            myElementRef.value?.offsetHeight - 90 - searchBox.value?.offsetHeight;
    }
};

const pageChange = (currentPage) => {
    page.value = currentPage;
    getSearch(searchData)
}

const limitChange = (currentLimit) => {
    limit.value = currentLimit;
    getSearch(searchData)
}

onMounted(() => {
    try {
        nextTick(() => {
            offHeighths();
        });
        window.onresize = () => {
            nextTick(() => {
                offHeighths();
            });
        };
        tableHeaderFn();
        applyLabels();
        init();
    } catch { }
});

onUnmounted(() => {
    window.onresize = null;
});

// 查询过来的数据
const getSearch = (params) => {
    const form = listToMap(toRaw(params), { value: 'value', key: 'field' })
    const requestParams = {
        page: page.value,
        limit: limit.value,
        ...form
    }
    state.loading = true
		pageListApi(JSON.stringify(requestParams)).then(res => {
        maxPage.value = res?.maxPage ?? 0;
        state.tableData = res?.data?.map(item => {
            return {
                ...item,
                status: listToMap(statusOptions, {})[item.status],
            }
        }) ?? []
    }).finally(() => {
		state.loading = false
	})
};

// 表头筛选
const tableHeaderFn = () => {
    state.tableHeader = state.column.filter((v) => {
        if (v.show) {
            return v.show == true;
        } else {
            v.show = false;
        }
    });
};
</script>

<style lang="less" scoped>
.finance_box {
    flex: 1;
    overflow: auto;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
    margin-right: 10px;
}

.btn_box {
    height: 40px;
    display: flex;
}

.table_box {
    width: 100%;
}

/deep/.el-button-group .el-button--primary:first-child {
    background-color: #1e6aed;
    border: none;
}

.serBtn {
    margin-left: 10px;
    background-color: #f0f0f0;
    color: #000;
    border: none;
}

.serBtn:hover {
    background-color: #f0f0f0;
    color: #000;
}

.opBtn {
    // margin: 0 !important;
    margin: 0 10px 0 0;
}

.opBtn:hover {
    color: #e6a755;
}
</style>
